import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const components = {
  table: ({ node, ...p }) => <div className="table-wrap"><table {...p} /></div>,
  a: ({ node, ...p }) => <a {...p} target="_blank" rel="noopener noreferrer" />,
};

export function Markdown({ children, className = "lesson-prose", testId }) {
  return (
    <div className={className} data-testid={testId}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>{children || ""}</ReactMarkdown>
    </div>
  );
}
